import * as React from 'react'
import StandardInput from './standard-input'
import * as moment from 'moment'
import './date-picker.css'


export default class extends React.Component<any, any>{


    componentDidMount(){
        global["$"]('#' + this.props.field).on("change", this.onDateChange.bind(this) );
    }


    componentWillUnmount(){
        global["$"]('#' + this.props.field).off("change", this.onDateChange.bind(this) );
    }


    onDateChange(e){
        this.props.updateField(this.props.field, e.target.value);
    }


    render(){
        const startDate = this.props.startDate || '-0d'
        const endDate = this.props.endDate;
        const format = 'dd/mm/yyyy';

        const childProps = {
            ...this.props,
            inputProps:{
                "data-provide":"datepicker",
                "data-date-autoclose":"true",
                "data-date-format": format,
                "data-date-start-date":startDate,
                "data-date-end-date":endDate
            }
        }

        return <StandardInput { ...childProps }/>
    }

}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/date-picker.tsx